
		document.addEventListener('DOMContentLoaded', () => {
		const slider = document.querySelector('.js-staff-slider');
		if (!slider) return;

		const track = slider.querySelector('.staff-slider__track');
		if (!track) return;

		const items = Array.from(track.children);
		if (!items.length) return;

		// 複製
		items.forEach(item => {
			track.appendChild(item.cloneNode(true));
		});

		const singleWidth = items.reduce((total, item) => {
			return total + item.offsetWidth;
		}, 0);

		//  初期位置を -singleWidth にする
		let posX = -singleWidth;
		const speed = 0.5;

		function animate() {
			posX += speed;

			// 0に戻ったら、また左へ戻す
			if (posX >= 0) {
			posX = -singleWidth;
			}

			track.style.transform = `translateX(${posX}px)`;
			requestAnimationFrame(animate);
		}

		animate();
		});
